import { Popover, OverlayTrigger } from "react-bootstrap"
import { useLanguage } from "../../contexts/LanguageContext"

/**
 * Information tooltip that displays on hover/focus.
 * Shows translated alert text from element configuration.
 * @param {Object} props
 * @param {Object} props.element - Configuration element with alert property
 * @returns {JSX.Element}
 */
function InfoPopover({ element }) {
  const { t } = useLanguage()

  if (!element) {
    return <div className="infoPopover" />
  }

  const popover = (
    <Popover id={`popover-info-${element.id || "default"}`} className="popover-info" title="Popover">
      {t(element.alert)}
    </Popover>
  )

  return (
    <div className="infoPopover">
      {element.alert ? (
        <OverlayTrigger trigger={["hover", "focus"]} placement="top" overlay={popover}>
          <span className="alertInfo">&#x1F6C8;</span>
        </OverlayTrigger>
      ) : null}
    </div>
  )
}

export default InfoPopover
